module.exports = __webpack_public_path__ + "img/icon_bottom1.cd5bf71.png";